<template>
  <Fragment>
    <router-view :key="key" />
  </Fragment>
</template>
<script>
export default {
  computed: {
    key() {
      return this.$route.name;
    },
  },
};
</script>
